import { z } from 'zod';

// Database-related exports for shared use across the monorepo
export const zodiacSignPgEnum = z.enum([
  'Aries',
  'Taurus',
  'Gemini',
  'Cancer',
  'Leo',
  'Virgo',
  'Libra',
  'Scorpio',
  'Sagittarius',
  'Capricorn',
  'Aquarius',
  'Pisces',
]);

export const subscriptionStatusPgEnum = z.enum(['stargazer', 'cosmic-navigator', 'cosmic-oracle']);

export const questStatusPgEnum = z.enum(['incomplete', 'complete', 'claimed']);

export const shopItemTypePgEnum = z.enum(['theme', 'frame']);

export type SubscriptionStatus = z.infer<typeof subscriptionStatusPgEnum>;
export type QuestStatus = z.infer<typeof questStatusPgEnum>;
export type ShopItemType = z.infer<typeof shopItemTypePgEnum>;
